module.exports = {
	"Play": "Oynat",
	"Pause": "Duraklat",
	"Current Time": "Süre",
	"Duration Time": "Toplam Süre",
	"Remaining Time": "Kalan Süre",
	"Stream Type": "Yayın Tipi",
	"LIVE": "CANLI",
	"Loaded": "Yüklendi",
	"Progress": "Yükleniyor",
	"Fullscreen": "Tam Ekran",
	"Non-Fullscreen": "Küçük Ekran",
	"Mute": "Ses Kapa",
	"Unmute": "Ses Aç",
	"Playback Rate": "Oynatma Hızı",
	"Subtitles": "Altyazı",
	"subtitles off": "Altyazı Kapalı",
	"Captions": "Ek Açıklamalar",
	"captions off": "Ek Açıklamalar Kapalı",
	"Chapters": "Bölümler",
	"You aborted the media playback": "Video oynatmayı iptal ettiniz",
	"A network error caused the media download to fail part-way.": "Video indirilirken bağlantı sorunu oluştu.",
	"The media could not be loaded, either because the server or network failed or because the format is not supported.": "Video oynatılamadı, ağ ya da sunucu hatası veya belirtilen format desteklenmiyor.",
	"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "Tarayıcınız desteklemediği için videoda hata oluştu.",
	"No compatible source was found for this media.": "Video için kaynak bulunamadı.",
	"Play Video": "Videoyu Oynat",
	"Close": "Kapat",
	"Modal Window": "Modal Penceresi",
	"This is a modal window": "Bu bir modal penceresidir",
	"This modal can be closed by pressing the Escape key or activating the close button.": "Bu modal ESC tuşuna basarak ya da kapata tıklanarak kapatılabilir.",
	", opens captions settings dialog": ", ek açıklama ayarları menüsünü açar",
	", opens subtitles settings dialog": ", altyazı ayarları menüsünü açar",
	", selected": ", seçildi"
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-video-player/lang/tr.json
// module id = 264
// module chunks = 81